import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import SuccessIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(
  ({ palette }) => ({
    root: {
      background: palette.cncUI.primary.gray['+8'],
      color: palette.cncUI.primary.gray['+0'],
      boxShadow: palette.cncUI.shadow.container.default,
      borderRadius: 2,
      borderLeft: `4px solid ${palette.cncUI.primary.gray['+0']}`,
      padding: '8px 0',
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontSize: 14,
      '& .cncui-alert-message': {
        margin: '8px 16px',
        display: 'flex',
        flexDirection: 'column',
      },
      '& .cncui-snackbar-alert-title': {
        fontWeight: 700,
        display: 'block',
        marginBottom: 4,
        marginTop: -4,
      },
    },
    fullWidth: { width: '100%' },
    info: {
      background: palette.cncUI.default['+10'],
      borderLeft: `4px solid ${palette.cncUI.default.primary}`,
      '& .cncui-alert-icon': {
        color: palette.cncUI.default.primary,
        margin: '6px 8px',
      },
      '& .cncui-alert-message': {
        marginLeft: 0,
      },
    },
    success: {
      background: palette.cncUI.alert.green.powder,
      borderLeft: `4px solid ${palette.cncUI.alert.green.primary}`,
      '& .cncui-alert-icon': {
        color: palette.cncUI.alert.green.primary,
        margin: '6px 8px',
      },
      '& .cncui-alert-message': {
        marginLeft: 0,
      },
    },
    warning: {
      background: palette.cncUI.alert.yellow.powder,
      borderLeft: `4px solid ${palette.cncUI.alert.yellow.primary}`,
      '& .cncui-alert-icon': {
        color: palette.cncUI.alert.yellow.primary,
        margin: '6px 8px',
      },
      '& .cncui-alert-message': {
        marginLeft: 0,
      },
    },
    error: {
      background: palette.cncUI.alert.red.powder,
      borderLeft: `4px solid ${palette.cncUI.alert.red.primary}`,
      '& .cncui-alert-icon': {
        color: palette.cncUI.alert.red.primary,
        margin: '6px 8px',
      },
      '& .cncui-alert-message': {
        marginLeft: 0,
      },
    },
    noBorder: {
      borderLeft: 'none',
    },
    inline: {
      '& .cncui-alert-message': {
        flexDirection: 'row',
        alignItems: 'center',
        '& .cncui-snackbar-alert-title': {
          marginTop: 0,
          marginRight: 12,
        },
      },
    },
  }),
  { name: 'CncUI-Alert' },
);

const Alert = props => {
  const classes = useStyles();
  const {
    children,
    className,
    info,
    success,
    warning,
    error,
    fullWidth,
    icon = null,
    noBorder = false,
    title = null,
    inline = null,
    ...other
  } = props;

  const options = {
    className: clsx(
      'cncui-alert',
      classes.root,
      fullWidth && classes.fullWidth,
      info && classes.info,
      success && classes.success,
      warning && classes.warning,
      error && classes.error,
      noBorder && classes.noBorder,
      inline && classes.inline,
      className,
    ),
  };

  let Icon = icon;
  if (!Icon && info) Icon = InfoIcon;
  if (!Icon && success) Icon = SuccessIcon;
  if (!Icon && warning) Icon = WarningIcon;
  if (!Icon && error) Icon = ErrorIcon;

  return (
    <Box {...options} {...other}>
      {Icon && <Icon className="cncui-alert-icon" />}
      <div className="cncui-alert-message">
        {title && <span className="cncui-snackbar-alert-title">{title}</span>}
        {children}
      </div>
    </Box>
  );
};

export default Alert;
